import EventsSection from "../../Components/EventSection/EventSection";
import HeroSection from "../../Components/HeroSection/HeroSection";
import SectionContainer from "../../Components/SectionContainer/SectionContainer";

const HomePage = () => {
  return (
    <>
      <SectionContainer sectionSize="full" backgroundColor="#617677ff">
        <HeroSection />
      </SectionContainer>
      <SectionContainer sectionSize="content" backgroundColor="#7e9a9cff">
        <EventsSection />
      </SectionContainer>
    </>
  );
};

export default HomePage;
